import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../shared/session/session.service';
import { tap, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'ls-switch-account',
  templateUrl: './switch-account.component.html',
  styleUrls: ['./switch-account.component.scss']
})
export class SwitchAccountComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<Subscription> = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) {}

  public ngOnInit(): void {
    this.sessionService.sessionStarted$
      .pipe(
        tap((started: boolean) => {
          if (started) {
            setTimeout(() => {
              this.router.navigateByUrl(
                this.route.snapshot.paramMap.get('redirect')
              );
            }, 2000);
          }
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
